import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import size from '../../utills/size'

export const resultsCountStyles = {
    color: 'cav_light_input_gray',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(13)],
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: pxToRem(1),
    marginLeft: 'auto'
}

export const availableAtStoreStyle = {
    fontSize: pxToRem(13),
    letterSpacing: pxToRem(1),
    fontWeight: 400,
    marginLeft: pxToRem(10)
}

export const adjustFiltersStyles = {
    background: 'gray.75',
    paddingBlock: pxToRem(10),
    paddingInline: [pxToRem(7), pxToRem(20)],
    display: 'flex',
    alignItems: ['start', 'center']
}

export const informationIconStyles = {
    height: [pxToRem(18), pxToRem(24)],
    marginRight: pxToRem(10),
    width: [pxToRem(18), pxToRem(24)]
}

export const plpAboveFooter = {
    mb: {base: pxToRem(30), md: pxToRem(40)},

    h3: {
        color: 'black',
        fontFamily: fonts.primary,
        fontSize: [pxToRem(16), pxToRem(16), pxToRem(18), pxToRem(18)],
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        letterSpacing: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(3)],
        textTransform: 'uppercase',
        marginTop: [pxToRem(20), pxToRem(20), pxToRem(30), pxToRem(30)],
        marginBottom: [pxToRem(10), pxToRem(10), pxToRem(15), pxToRem(15)]
    },
    'h3:nth-child(1)': {
        marginTop: [pxToRem(0)]
    },
    p: {
        color: 'black',
        fontFamily: fonts.primary,
        fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1), pxToRem(1)],
        margin: 0,
        a: {
            color: 'black',
            textDecoration: 'underline'
        }
    }
}

export const size1x1 = {
    '.html-slot-container': {
        height: '100%'
    },

    '.content': {
        padding: `${pxToRem(32)} ${pxToRem(22)}`
    },

    '[id^="category-bill-board-"]': {
        height: '100%'
    },

    '.button-primary': {
        minWidth: ['unset', 'unset', 'unset', 'unset']
    }
}

export const size2x1 = {
    [`@media (max-width: ${size.md})`]: {
        height: pxToRem(270)
    },

    '.html-slot-container': {
        height: '100%'
    },

    '.content': {
        padding: `${pxToRem(32)} ${pxToRem(22)}`
    },

    '[id^="category-bill-board-"]': {
        height: '100%'
    },

    '.button-primary': {
        [`@media (min-width: ${size.md}) and (max-width: ${size.lg})`]: {
            minWidth: 'auto'
        }
    }
}
